import { Flex, Form, Input } from "antd";
import { SendOutlined, UploadOutlined } from "@ant-design/icons";
import { useI18n } from "@/contexts/I18nContext";
import { useForm } from "antd/es/form/Form";
import toast from "react-hot-toast";
import FileUploadButton from "../FileUploadButton";
import { roleType } from "@/constants";
import { useFileUpload } from "@/contexts/FileUploadContext";
import { useEffect, useRef, useState } from "react";
import styles from "./index.module.scss";

interface MessageInputProps {
  curMode?: string | null;
  handleSendMessage: (values: any) => void;
  onFileChange: (file: any) => void;
}

//发送信息表单组件
const MessageInput = ({
  curMode,
  handleSendMessage,
  onFileChange,
}: MessageInputProps) => {
  const [form] = useForm();
  const { formatMessage } = useI18n();
  // 使用全局文件上传状态
  const { fileUploading } = useFileUpload();
  const inputRef = useRef<any>(null);
  const sendButtonRef = useRef<any>(null);
  const [showFileUpload, setShowFileUpload] = useState<boolean>(false);

  // 检查URL路径是否包含/tmp/chat.html, 包含/tmp/chat.html路径的页面为临时聊天页面，始终显示上传附件的标志入口
  useEffect(() => {
    if (typeof window !== "undefined") {
      const pathname = window.location.pathname;
      // 检查路径是否包含/tmp/chat.html
      setShowFileUpload(pathname.includes("/tmp/chat.html"));
    }
  }, []);

  const handleInputFoucs = () => {
    inputRef.current?.focus();
  };

  // 在组件加载和发送消息后聚焦到输入框
  useEffect(() => {
    // 组件加载后聚焦到输入框
    setTimeout(() => {
      handleInputFoucs();
    }, 100);
  }, []);

  return (
    <div className={styles.inputContent}>
      <Form
        layout="inline"
        form={form}
        onFinish={(values) => {
          form?.resetFields();
          handleSendMessage(values);
          // 发送消息后重新聚焦到输入框
          setTimeout(() => {
            handleInputFoucs();
          }, 100);
        }}
        onFinishFailed={({ errorFields }) => {
          const firstError = errorFields[0]?.errors[0];
          if (firstError) {
            toast.error(firstError);
          }
          // 验证失败后也重新聚焦到输入框
          setTimeout(() => {
            handleInputFoucs();
          }, 100);
        }}
        autoComplete="off"
        style={{ alignItems: "center" }}
      >
        <Form.Item
          name="question"
          style={{ width: "100%" }}
          rules={[
            {
              required: true,
              validator: (_, value) => {
                if (!value || value.trim() === "") {
                  return Promise.reject(formatMessage("messageTooShort"));
                }
                // 自定义验证规则
                if (value && value.length < 2) {
                  return Promise.reject(formatMessage("messageTooShort"));
                }
                if (value && value.length > 200) {
                  return Promise.reject(formatMessage("messageTooLong"));
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input
            ref={inputRef}
            placeholder={formatMessage("placeholderText")}
            disabled={fileUploading}
            onPressEnter={(e) => {
              // 防止表单默认提交行为
              e.preventDefault();
              if (!fileUploading) {
                // 回车时触发发送按钮的点击事件，以确保埋点能被正确触发
                const sendButton =
                  document.getElementById("add_to_send_button");
                if (sendButton) {
                  sendButton.click();
                } else {
                  // 如果找不到按钮元素，直接提交表单
                  form?.submit();
                }
              }
            }}
            suffix={
              <Flex
                gap={12}
                className={fileUploading ? `${styles.disabledSuffix}` : ""}
              >
                {/* 人工客服模式下或URL包含/tmp/chat.html时才显示上传附件标志 */}
                {(curMode === roleType.cs || showFileUpload) && (
                  <FileUploadButton
                    onFileChange={onFileChange}
                    formatMessage={formatMessage}
                    showUploadList={false}
                  >
                    <UploadOutlined />
                  </FileUploadButton>
                )}
                <SendOutlined
                  ref={sendButtonRef}
                  id="add_to_send_button"
                  data-track-element
                  onClick={() => {
                    if (!fileUploading) {
                      form?.submit();
                    }
                  }}
                />
              </Flex>
            }
          />
        </Form.Item>
      </Form>
    </div>
  );
};

export default MessageInput;
